<template>
    <div class="d-flex justify-content-center justify-content-sm-between flex-wrap">
        
        <div>
            <p class="card-category" v-if="showCount">
                {{ $t('common.paging-count', { from: from + 1, to, total }) }}
            </p>
        </div>
        
        <base-pagination
            class="pagination-no-border"
            v-model="paging.currentPage"
            :per-page="paging.perPage"
            :total="paging.total"
        >
        </base-pagination>

    </div>
</template>

<script>
    export default {

        props: {
            paging: {
                type: Object,
                required: true
            },
            showCount: {
                type: Boolean,
                default: false
            }
        },

        computed: {
            from() {
                return (this.paging.perPage * this.paging.currentPage) - this.paging.perPage
            },
            to() {
                let highBound = this.from + this.paging.perPage;
                if (this.total < highBound) {
                    highBound = this.total;
                }
                return highBound;
            },
            total() {
                return this.paging.total
            }
        }
    }
</script>

<style scoped>
    
    .card-category {
        text-transform: none;
    }

</style>
